import { useQuery, queryOptions } from '@tanstack/vue-query';
import { type Ref, unref, computed } from 'vue';
import httpClient from '../httpClient';
import type { MantaClient, PaginatedResponse } from '@/types';

/**
 * Searches the tenant's owners/clients via the scribe-backend proxy, which
 * forwards to manta (the source of truth) over M2M.
 */
export const useClientSearch = (query: Ref<string>) => {
  const enabled = computed(() => unref(query).trim().length >= 2);

  const fetcher = async (): Promise<MantaClient[]> => {
    const q = unref(query).trim();
    if (q.length < 2) return [];
    const response = await httpClient.get<
      PaginatedResponse<MantaClient> | MantaClient[]
    >('/v1/clients/search', { params: { q } });
    const data = response.data as PaginatedResponse<MantaClient> & {
      data?: MantaClient[];
    };
    return Array.isArray(response.data) ? response.data : (data.data ?? []);
  };

  return useQuery(
    queryOptions({
      queryKey: computed(() => ['scribeClientSearch', unref(query)]),
      queryFn: fetcher,
      enabled,
      staleTime: 10_000,
    }),
  );
};
